import React, { FC, useState, useEffect } from "react";
import { StylesProvider, createGenerateClassName } from "@material-ui/styles";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import "./ConfirmDeleteOrderModal.scss";
import iconActionDanger from "../../../../assets/img/svg/ic-actions-danger.svg";
const Button = React.lazy(() => import("ui/Button"));
const generateClassName = createGenerateClassName({
  seed: "confirm-delete-order-modal",
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

const ConfirmDeleteOrderModal: FC<any> = ({
  isOpen,
  handleOpenModalClick,
  handleDelete,
  strTitle,
  strDesLine1,
  strDesLine2,
  strCancel,
  strDelete,
  isInfoModal,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const clickDelete = () => {
    if (handleDelete) {
      handleDelete();
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (handleOpenModalClick) {
      handleOpenModalClick(false);
    }
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  // useEffect(() => {
  //   console.log(divRef)
  //   console.log(divRef.current)
  //   if (divRef.current) {
  //     console.log(`hookRef div width: ${divRef.current.clientWidth}`);
  //   }
  // }, []);

  return (
    <StylesProvider generateClassName={generateClassName}>
      {/* <div  ref={divRef}> */}
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          className="modalDeleteQshpDraft"
        >
          <div className="modalDeleteQshpDraft__container">
            {/* <div className="modalProof__top">
              <p className="modalProof__title">Proof of delivery</p>
              <button onClick={handleClose} className="modalProof__button-close">
                <img src={iconClose} alt="close" />
              </button>
            </div>  */}
            <div className="modalDeleteQshpDraft__body">
              <div className="modalDeleteQshpDraft__image">
                <img src={iconActionDanger} alt="icon" />
              </div>
              <p className="modalDeleteQshpDraft__title">{strTitle ? strTitle : "Hey, wait!"}</p>
              <div className="modalDeleteQshpDraft__desc" style={{ width: "100%" }}>
                {/* {listInvalid &&
                <>
                  <div className="modalDeleteQshpDraft__desc-sub">
                    <p>Tracking ID <strong>{listInvalid}</strong> is invalid.</p>
                  </div>
                </>}
                {!listValid ? <p>Please review the tracking ID</p> : <p>Please review the tracking ID or proceed to track</p>} */}

                <>
                  <div className="modalDeleteQshpDraft__desc-sub">
                    <p>{strDesLine1 ? strDesLine1 : "Are you sure you want to delete this order?"}</p>
                    {!isInfoModal && <p>{strDesLine2 ? strDesLine2 : "You can't undo this action"}</p>}
                  </div>
                </>
              </div>
            </div>
            {isInfoModal ? (
              <div className="modalDeleteQshpDraft__box">
                <div className="modalDeleteQshpDraft__button">
                  <Button
                    label={strDelete ? strDelete : "OK"}
                    onClick={handleClose}
                    type="primary"
                  />
                </div>
              </div>
            ) : (
              <div className="modalDeleteQshpDraft__box">
                <div className="modalDeleteQshpDraft__button">
                  <Button
                    type="secondary"
                    label={strCancel ? strCancel : "Cancel"}
                    onClick={handleClose}
                  />
                </div>
                <div className="modalDeleteQshpDraft__button">
                  <Button
                    label={strDelete ? strDelete : "Delete Order"}
                    onClick={clickDelete}
                    type="primary"
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </StylesProvider>
  );
};

export default ConfirmDeleteOrderModal;
